import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HealthCheckService } from '@core/services/health-check/health-check.service';

@Component({
    selector: 'app-server-connectivity-banner',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div class="connectivity-banner" *ngIf="(isServerRunning$ | async) === false">
      <div class="banner-content">
        <div class="icon-wrapper">
          <span class="material-symbols-outlined">wifi_off</span>
        </div>
        <div class="text-content">
          <span class="title">No Connection</span>
          <span class="subtitle">MedEase server is unreachable</span>
        </div>
        <button class="retry-btn" (click)="retry()">Retry</button>
      </div>
    </div>
  `,
    styleUrls: ['./server-connectivity-banner.component.scss']
})
export class ServerConnectivityBannerComponent {
    private healthCheckService = inject(HealthCheckService);
    isServerRunning$ = this.healthCheckService.isServerRunning$;

    retry() {
        this.healthCheckService.checkHealth();
    }
}
